import { useState } from 'react';
import { Link } from 'react-router-dom';
import './FAQ.css';

const FAQS = [
  {
    q: 'How does SnapScrap work?',
    a: 'Simply post your unwanted scrap metal, upload a few photos and provide your collection details. Your job is then made available to licensed local scrap collectors. Once a collector accepts it, you’ll receive updates about your collection.',
  },
  {
    q: 'Is it free to post my scrap?',
    a: 'Yes. Posting your unwanted scrap metal on SnapScrap is free.',
  },
  {
    q: 'How quickly can my scrap be collected?',
    a: 'Collection times depend on collector availability and your location. Once your job is accepted, you’ll receive updates so you know what’s happening.',
  },
  {
    q: 'What types of scrap do you collect?',
    a: 'SnapScrap is designed for unwanted metal and scrap items such as washing machines, cookers, dishwashers, radiators, boilers, bikes, metal gates, metal doors, car batteries and other suitable metal items.',
  },
  {
    q: 'Do you collect fridges and freezers?',
    a: 'No. Fridges and freezers are not currently accepted through SnapScrap.',
  },
  {
    q: 'Do I need to be at home for collection?',
    a: 'Not always. If the scrap can be safely accessed without you being there, you can provide collection and access instructions when posting the job.',
  },
  {
    q: 'Can businesses use SnapScrap?',
    a: 'Yes. SnapScrap can also be used by businesses that regularly generate unwanted metal and scrap.',
  },
  {
    q: 'How do I become a SnapScrap collector?',
    a: 'Register as a collector and provide the required business and licence information for verification.',
  },
];

function Chevron({ open }) {
  return (
    <svg
      className={`faq-chevron ${open ? 'is-open' : ''}`}
      width="18"
      height="18"
      viewBox="0 0 12 12"
      fill="none"
      aria-hidden="true"
    >
      <path
        d="M2.5 4.5L6 8l3.5-3.5"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export default function FAQ() {
  const [openIndex, setOpenIndex] = useState(null);

  return (
    <section className="faq" aria-labelledby="faq-heading">
      <div className="faq-inner">
        <h2 id="faq-heading">Frequently Asked Questions</h2>

        <div className="faq-list">
          {FAQS.map((item, index) => {
            const open = openIndex === index;
            const panelId = `faq-panel-${index}`;
            const buttonId = `faq-button-${index}`;

            return (
              <div key={item.q} className={`faq-item ${open ? 'is-open' : ''}`}>
                <h3>
                  <button
                    id={buttonId}
                    type="button"
                    className="faq-trigger"
                    aria-expanded={open}
                    aria-controls={panelId}
                    onClick={() => setOpenIndex(open ? null : index)}
                  >
                    <span>{item.q}</span>
                    <Chevron open={open} />
                  </button>
                </h3>
                <div
                  id={panelId}
                  role="region"
                  aria-labelledby={buttonId}
                  className="faq-panel"
                  hidden={!open}
                >
                  <p>{item.a}</p>
                </div>
              </div>
            );
          })}
        </div>

        <p className="faq-more">
          <Link to="/faqs">View all frequently asked questions</Link>
        </p>
      </div>
    </section>
  );
}
